
export default function Footer() {
  return (
    <footer className="bg-[#0A0A0A] border-t border-[#3B82F6]/20 py-12 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col items-center text-center space-y-6">
          <div className="flex items-center gap-3">
            <img src="https://static.readdy.ai/image/68c02a6c7db1e4f446ae7031426f220f/48a0b6b9e68cfbf8d21754fa0f3ebce1.png" alt="ServiceBizLab" className="h-12 w-auto" />
            <span className="text-2xl font-black">ServiceBizLab</span>
          </div>
          
          <p className="text-xl font-bold text-[#3B82F6]">
            Websites That Turn Visitors Into Booked Jobs
          </p>
          
          <div className="space-y-2">
            <p className="text-gray-400">
              <strong className="text-white">Email:</strong> hello@servicebizlab.com
            </p>
          </div>

          <div className="pt-6 border-t border-[#3B82F6]/20 w-full">
            <p className="text-gray-500 text-sm">
              © {new Date().getFullYear()} ServiceBizLab. All rights reserved. | 
              <a 
                href="https://readdy.ai/?ref=logo" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-[#3B82F6] hover:underline ml-1 cursor-pointer"
              >
                Website Builder
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
